module.exports = __webpack_public_path__ + "resources/img/img_datahunt4.407237163dad2f4c889bc15555e7f74f.png";